$(document).ready(function(){
   var lang = ""
  $(".lang-flag").click(function(){
    var clicks = ($(this).data('clicks') == undefined)? true : $(this).data('clicks');
    console.log(typeof(clicks));
    if (clicks) {
       $(".language-dropdown").toggleClass("open");
       lang = $(".language-dropdown").find(".lang-flag")[0].classList[1];
    } else {
       if(lang.length > 0 && $(".language-dropdown").hasClass("open")) {
        switch(lang) {
            case "lang-en":
              $(".lang-flag #selected-language")[0].href = "https://yuccs.eu";
              break;
            case "lang-de":
              $(".lang-flag #selected-language")[0].href = "https://yuccs.de";
              break;
            default:
              $(".lang-flag #selected-language")[0].href = "https://yuccs.com";
        }
      }
    }
    $(this).data("clicks", !clicks); 	
  });
  $("ul.lang-list li").click(function(){
    $("ul.lang-list li").removeClass("selected");
    $(this).addClass("selected");
    if($(this).hasClass('lang-en')){
      $(".language-dropdown").find(".lang-flag").addClass("lang-en").removeClass("lang-es").removeClass("lang-de");
    } else if($(this).hasClass('lang-de')){
      $(".language-dropdown").find(".lang-flag").addClass("lang-de").removeClass("lang-es").removeClass("lang-en");
    } else if($(this).hasClass('lang-es')){
      $(".language-dropdown").find(".lang-flag").addClass("lang-es").removeClass("lang-de").removeClass("lang-en");
    } else{
      $(".language-dropdown").find(".lang-flag").addClass("lang-es").removeClass("lang-en").removeClass("lang-de");
    }
    $(".language-dropdown").removeClass("open");
  });
  
  
  (function($) {

    /**
   * Copyright 2012, Digital Fusion
   * Licensed under the MIT license.
   * http://teamdf.com/jquery-plugins/license/
   *
   * @author Sam Sehnert
   * @desc A small plugin that checks whether elements are within
   *     the user visible viewport of a web browser.
   *     only accounts for vertical position, not horizontal.
   */

    $.fn.visible = function(partial) {

      var $t            = $(this),
          $w            = $(window),
          viewTop       = $w.scrollTop(),
          viewBottom    = viewTop + $w.height(),
          _top          = $t.offset().top,
          _bottom       = _top + $t.height(),
          compareTop    = partial === true ? _bottom : _top,
          compareBottom = partial === true ? _top : _bottom;

      return ((compareBottom <= viewBottom) && (compareTop >= viewTop));

    };

  })(jQuery);

  var win = $(window);

  var allMods = $(".module");

  allMods.each(function(i, el) {
    var el = $(el);
    if (el.parent().visible(true)) {
      el.addClass("already-visible"); 
      el.addClass("come-in"); 
    } 
  });

  win.scroll(function(event) {
    allMods.each(function(i, el) {
      var el = $(el);
      if (el.parent().visible(true)) {
        el.addClass("come-in"); 
      } 
    });

  });
  
})



$(document).ready(updateToolTipText);
$('.color-wrapper li').click(updateToolTipText);
$('.swatch-element').click(updateToolTipText);

function updateToolTipText() {
  setTimeout(function(){ 
    if(!$("#id_input_hidden_for_reserv input").val()) {
      $(".tooltiptext").css("display", "none");
      return;
    }

    let selectedLi = $(".swatch.color-wrapper .swatch-element input:checked").parent();
    $(".tooltiptext").css("display", "none");
    $(".tooltiptext."+selectedLi.data("group").replace("á","a")).css("display", "block"); 
  }, 1000);
  
}



document.addEventListener('readystatechange', ()=>{
  for(let button of document.getElementsByClassName("showMoreButton")){
    button.addEventListener("click", (e)=>showMoreColors(e));
  }
});

function showMoreColors(e) {
  let elements = e.target.closest(".productWholeContainer").getElementsByClassName("dontShow");
  for(let hiddenProduct of elements){
    if(!hiddenProduct.classList.contains("productSquareContainer"))
      continue;
    hiddenProduct.classList.add("dontShowOverride");
  }
  e.target.classList.add("dontShow");
}



function showEveryOne(thisElement) {
  deActiveAllListElements();
  thisElement.classList.add("active");
  for(let div of document.querySelectorAll(".productCollectionContainer .blockContainer")) {
    div.style.display = "block";
  	div.querySelector('.showMoreButton').classList.remove("dontShow");
    
    let elements = div.getElementsByClassName("dontShow");
    for(let hiddenProduct of elements){
      hiddenProduct.classList.remove("dontShowOverride");
    }
  }
}
function showOnlyThisOne(thisElement, blockId) {
  deActiveAllListElements();
  thisElement.classList.add("active");
  for(let div of document.querySelectorAll(".productCollectionContainer .blockContainer")) {
    div.style.display = "none";
  }
  document.getElementById(`block_id_${blockId}`).style.display = "block";
  document.getElementById(`block_id_${blockId}`).querySelector('.showMoreButton').click();
}
function deActiveAllListElements() {
  for(let div of document.querySelectorAll("#scrollTarget .modelSelector")) {
    div.classList.remove("active");
  }
}

/**
 * @param {String} date 
 * 
 * @return {Date} instance of class Date
 */
function parseSlashDate( date ) {
  // La fecha está vacía
  if ( !date ) return null;

  date = date.trim().replaceAll(' ', '') // eliminamos espacios
  date = date.replaceAll(/[^0-9]/g, '/') // sustituimos todo lo que no sean números por '/'

  try {
  
    let [day, month, year] = date.split('/');

    day   = day.padStart(2, '0');
    month = month.padStart(2, '0');

    // Si nos han pasado por ejemplo 22, pues tendremos que dejar el año como 2022
    // asumimos que esta web no va a pasar del año 9999 d.C. :(
    if ( year.length === 2 ) {
      year = `${(new Date()).getFullYear().toString().substr(0,2)}${year}`;

    // No sabemos qué narices nos han pasado:
    } else if ( year.length != 4 ) {
      return null;
    }

    // Formato para pasárselo a la clase Date
    return `${year}-${month}-${day}`;

  // No se ha podido formatear bien, devolvemos null
  } catch( error ) {
    console.log(error);
    return null;
  }
}

function checkIsHappyDaysEnabled() {
  let happyDaysData = document.getElementById('tt-happy-days-data');

  // No hay elemento con la info de las banderillas o el elemento no tiene nada, salimos
  if ( !happyDaysData ) return false;
  if (!happyDaysData.innerHTML) return false;

  // Tratamos de cargar la info del customizer:
  try {
    happyDaysData = JSON.parse(happyDaysData.innerHTML);
  } catch( error ) {
    console.warn('Happy Days data could not be loaded.');
    return false;
  }

  // Comprobamos si está la promoción activada:
  if ( !happyDaysData.isHappyDaysEnabled ) {
    console.warn('Happy Days is not enabled.');
    return false;
  }

  // Comprobamos que hay una imagen para la banderilla:
  if ( !happyDaysData.isHappyDaysEnabled ) {
    console.warn('Happy Days flag image is not defined.');
    return false;
  }

  // Comprobamos las fechas:
  let { fromDate, toDate, imageUrl } = happyDaysData;

  fromDate = parseSlashDate(fromDate);
  toDate   = parseSlashDate(toDate);

  // Fecha actual para determinar si mostrar la banderilla o no
  let now = new Date();
  now     = `${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getDate().toString().padStart(2, '0')}`;

  // Si alguna de las dos está vacía, la igualaremos a la fecha actual:
  fromDate = fromDate ?? now;
  toDate   = toDate   ?? now;
  console.log(fromDate, toDate, now);
  // Si from es mayor que to, no se muestra happy days
  if ( fromDate > toDate ) return false;

  // Si la fecha de inicio es mayor a la actual, tampoco
  if ( fromDate > now ) return false;

  // Si la fecha de fin es menor a la actual, tampoco
  if ( toDate < now ) return false;

  // En cualquier otro caso, sí se muestra happy days
  return imageUrl;
}

function renderHappyDaysFlag( imageUrl ) {
  // Seleccionamos todos los productos en los que vamos a tener que meter la banderilla:
  const happyDaysProducts = Array.from(document.getElementsByClassName('productSquare'))
    .filter(link => link.dataset.productShowHappyDaysFlag == "true" );

  happyDaysProducts.forEach(product => {
    const ribbon = document.createElement('div');
    ribbon.classList.add("ribbon", "ribbon-happy-days");
    ribbon.style.backgroundImage = `url("${imageUrl}")`;
    product.appendChild(ribbon)
  });
}

function checkIsHappyDaysClassicsEnabled() {
  let happyDaysClassicsData = document.getElementById('tt-happy-days-classics-data');
  
  // No hay elemento con la info de las banderillas o el elemento no tiene nada, salimos
  if ( !happyDaysClassicsData ) return false;
  if (!happyDaysClassicsData.innerHTML) return false;

  // Tratamos de cargar la info del customizer:
  try {
    happyDaysClassicsData = JSON.parse(happyDaysClassicsData.innerHTML);
  } catch( error ) {
    console.warn('Happy Days data could not be loaded.');
    return false;
  }

  // Comprobamos si está la promoción activada:
  if ( !happyDaysClassicsData.isHappyDaysEnabled ) {
    console.warn('Happy Days is not enabled.');
    return false;
  }

  // Comprobamos que hay una imagen para la banderilla:
  if ( !happyDaysClassicsData.isHappyDaysEnabled ) {
    console.warn('Happy Days flag image is not defined.');
    return false;
  }

  // Comprobamos las fechas:
  let { fromDate, toDate, imageUrl } = happyDaysClassicsData;

  fromDate = parseSlashDate(fromDate);
  toDate   = parseSlashDate(toDate);

  // Fecha actual para determinar si mostrar la banderilla o no
  let now = new Date();
  now     = `${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getDate().toString().padStart(2, '0')}`;

  // Si alguna de las dos está vacía, la igualaremos a la fecha actual:
  fromDate = fromDate ?? now;
  toDate   = toDate   ?? now;
  console.log(fromDate, toDate, now);
  // Si from es mayor que to, no se muestra happy days
  if ( fromDate > toDate ) return false;

  // Si la fecha de inicio es mayor a la actual, tampoco
  if ( fromDate > now ) return false;

  // Si la fecha de fin es menor a la actual, tampoco
  if ( toDate < now ) return false;

  // En cualquier otro caso, sí se muestra happy days
  return imageUrl;
}

function renderHappyDaysClassicsFlag( imageUrl ) {
  console.log("hola");
  // Seleccionamos todos los productos en los que vamos a tener que meter la banderilla:
  const happyDaysClassicsProducts = Array.from(document.getElementsByClassName('productSquare'))
    .filter(link => link.dataset.productShowHappyDaysClassicsFlag == "true" );

  happyDaysClassicsProducts.forEach(product => {
    const ribbon = document.createElement('div');
    ribbon.classList.add("ribbon", "ribbon-happy-days-classics");
    ribbon.style.backgroundImage = `url("${imageUrl}")`;
    product.appendChild(ribbon)
  });
}

function renderDiscountQuantity() {
    let discountedProducts = document.querySelectorAll(".discounted-price-data");
    if (!discountedProducts) return;

    discountedProducts.forEach(discountedProduct => {
        if(!discountedProduct.innerHTML) return;
        let data = discountedProduct.innerHTML;
        try {
          var parsedData = JSON.parse(`${data}`);
        } catch (error) {
          return console.error(`Error parsing JSON: ${data}`);
        }
        
        let discount = parseInt((parsedData.price - parsedData.compare_at_price) / 100);


        let parent = discountedProduct.parentElement;
            parent.style.position = "relative";

        let littleRibbon = document.createElement("div");
            littleRibbon.classList.add("ribbon", "ribbon-black");
            littleRibbon.innerHTML = `<b>${discount}€</b></div>`;

        var heightTagProduct = document.querySelector('.col-tag-product').clientHeight;
        if (heightTagProduct) {
          littleRibbon.style.top = heightTagProduct+"px";
        }

        parent.appendChild(littleRibbon);
        

    });

}

document.addEventListener('readystatechange', () => {
  const isHappyDaysFlagSet = checkIsHappyDaysEnabled();
  const isHappyDaysClassicsFlagSet = checkIsHappyDaysClassicsEnabled();

  if ( !!isHappyDaysFlagSet || !!isHappyDaysClassicsFlagSet ) {
    renderHappyDaysFlag( isHappyDaysFlagSet );
    renderHappyDaysClassicsFlag( isHappyDaysClassicsFlagSet );
    renderDiscountQuantity();
  }else {
    renderDiscountQuantity();
  }
});

window.addEventListener("appRuleTriggered", (data) => {
  // console.log("ERES DE ESPAÑA!!", data.detail.rule);
})

function renderSpecialPromos() {
    let specialPromos = document.querySelectorAll(".special-promo-data");
    if (!specialPromos) return;

    specialPromos.forEach(specialPromo => {
        if(!specialPromo.innerHTML) return;
        let date = specialPromo.innerHTML;

        let parent = specialPromo.parentElement;
            parent.style.position = "relative";

        if (parent.dataset.ribbonImage) {
          var littleRibbon = document.createElement("div");
            littleRibbon.classList.add("ribbon");
            littleRibbon.style.backgroundImage = `url(${parent.dataset.ribbonImage})`;
          parent.appendChild(littleRibbon);
        }
        console.log("asa")
        let countDownContainer = document.createElement("div");
            countDownContainer.classList.add("countDownContainer");
        parent.appendChild(countDownContainer);

        // Set the date we're counting down to
        var countDownDate = new Date(date).getTime();
        if (!countDownDate) return;

        // Update the count down every 1 second
        var x = setInterval(() => {
          // Get todays date and time
          var now = new Date().getTime();

          // Find the distance between now an the count down date
          var distance = countDownDate - now;

          // Time calculations for days, hours, minutes and seconds
          var days    = Math.floor( distance / (1000 * 60 * 60 * 24));
          var hours   = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          var seconds = Math.floor((distance % (1000 * 60)) / (1000));

          // Display the result in the element with id="demo"
          countDownContainer.innerHTML = (days > 0 ? `${days}d `:``) + `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

          // If the count down is finished, write some text 
          if (distance < 0) {
            clearInterval(x);
            countDownContainer.remove();
            littleRibbon.remove()
          }
        }, 1000);

    });

}
document.addEventListener('readystatechange', renderSpecialPromos);
// Modificado por DOMContentLoaded ya que en Safari no cargaba las funciones y no e visualizaban las banderillas.









// We check if we need to render the model selector
document.addEventListener('DOMContentLoaded', () => {
	// TEMP: Check if the Test parameter is on the URL
	//let params = new URLSearchParams(location.search);
    //if (!params.get("test-selector")) {
      //return;
    //}

	// If we do not find the selector we are not in a page where we need to render it
    let modelSelectorContainer = document.getElementById("model-selector");
    if (!modelSelectorContainer) return;

	// Check the width to only display the selector on mobile
	var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
	if (width > 600) return;

	// Show the button for the selector
	modelSelectorContainer.style.display = `block`;

	// Link the action to the button
    let modelSelectorBnt = modelSelectorContainer.querySelector(".model-selector-button");
	modelSelectorBnt.onclick = renderModelSelectorPopup;
	
});

// It will render the popup on the screen
var currentSelection = {};
function renderModelSelectorPopup() {
	let container = document.createElement("div");
  		container.classList.add("model-selector-bg-container");
 		
        let closeModelSelector = () => {
          container.remove();
        };
  
        container.onclick = (event) => {
          if (event.target !== container) return;
          closeModelSelector();
        };
  
  		let selector = document.createElement("div");
  			selector.classList.add("model-selector-container");
  
  			let selectorHead = document.createElement("div");
  				selectorHead.classList.add("model-selector-head");
  				
  				let selectorTitle = document.createElement("div");
  					selectorTitle.classList.add("model-selector-title");
  					selectorTitle.innerHTML = `Selecciona los modelos`;
  				selectorHead.appendChild(selectorTitle);
  				
  
  				let selectorClose = document.createElement("div");
  					selectorClose.classList.add("model-selector-close");
  					selectorClose.innerHTML = `<svg fill="currentColor" viewBox="0 0 24 24" width="24px" height="24px"><path d="M 4.7070312 3.2929688 L 3.2929688 4.7070312 L 10.585938 12 L 3.2929688 19.292969 L 4.7070312 20.707031 L 12 13.414062 L 19.292969 20.707031 L 20.707031 19.292969 L 13.414062 12 L 20.707031 4.7070312 L 19.292969 3.2929688 L 12 10.585938 L 4.7070312 3.2929688 z"/></svg>`;
  					selectorClose.onclick = closeModelSelector;
  				selectorHead.appendChild(selectorClose);
  
  
  			selector.appendChild(selectorHead);
  
  			let displayedProducts = document.getElementsByClassName("product-model-contender");
            let modelDictionary = {};
            for (let displayedProduct of displayedProducts) {
                let modelKey = displayedProduct.dataset.productModelKey;
                let modelName = displayedProduct.dataset.productModelName;
                if (!modelKey || !modelName) continue;
                modelDictionary[modelKey] = modelName;
            }
  			let selectorModelContainer = document.createElement("div");
  				selectorModelContainer.classList.add("single-models-container");
                for (let [modelKey, modelName] of Object.entries(modelDictionary)) {
                  selectorModelContainer.appendChild(getModelNode(modelKey, modelName));
                }
  			selector.appendChild(selectorModelContainer);
  
  			
  			let selectorFooter = document.createElement("div");
  				selectorFooter.classList.add("model-selector-footer"); 
  					
  				let selectorApplySearchFooter = document.createElement("div");
  					selectorApplySearchFooter.classList.add("yuccs-button-primary", "apply-model-selection");  
					selectorApplySearchFooter.innerHTML = `Aplicar selección`;
                    selectorApplySearchFooter.onclick = () => {
                      let presentProducts = document.getElementsByClassName("product-model-contender");
                      
                      let noneAreSelected = true;
                      for (let [modelKey, status] of Object.entries(currentSelection)) {
                      	if (status)
                          	noneAreSelected = false;
                      }
                      let shownProducts = 0;
                      for (let productLink of presentProducts) {
                        let modelKey = productLink.dataset.productModelKey;
                        if (!modelKey) continue;
                        
                        if (currentSelection[modelKey] || noneAreSelected) {
                          shownProducts++;
                          productLink.style.display = 'block';
                        } else {
                          productLink.style.display = 'none';
                        }
                      }
          			      closeModelSelector();
                      document.querySelectorAll(".featuredCollectionContainer").forEach(collectionContainer => {
                        let totalProducts = 0;
                        let hiddenProducts = 0;
                        collectionContainer.querySelectorAll(".product-model-contender").forEach(productContainer => {
                          totalProducts++;
                          if (productContainer.style.display === "none") {
                            hiddenProducts++;
                          }
                        });
                        if (hiddenProducts === totalProducts) {
                          collectionContainer.style.display = 'none';
                        } else {
                          collectionContainer.style.display = 'block';
                        }
                      });
                      /*if (shownProducts <= 0) {
                        let noResults = document.createElement("div");
                        	noResults.id = 'no-results-model-selector';
                        	noResults.innerHTML = `Selecciona al menos un modelo para ver los resultados`;
	                        document.getElementById("model-selector").appendChild(noResults);
                      } else {
                      	document.getElementById("no-results-model-selector")?.remove();
                      }*/
                    }
 				selectorFooter.appendChild(selectorApplySearchFooter);
  				
  			selector.appendChild(selectorFooter);
  
  		container.appendChild(selector);
  
  
  	document.body.appendChild(container);
}

function getModelNode(modelKey, modelName) {
	let div = document.createElement("div");
  		div.classList.add("model-single-selector");
  
  		let modelNameNode = document.createElement("div");
  			modelNameNode.classList.add("model-single-selector-name");
		  	modelNameNode.innerHTML = modelName;
  		div.appendChild(modelNameNode);
  
  		let modelStatusNode = document.createElement("div");
  			modelStatusNode.classList.add("model-single-selector-status");
		  	if (currentSelection[modelKey]) 
              	modelStatusNode.classList.add("active");
  		div.appendChild(modelStatusNode);
  
    div.onclick = () => {
      if (modelStatusNode.classList.contains("active")) {
        modelStatusNode.classList.remove("active");
		currentSelection[modelKey] = false;
        return;
      }
      modelStatusNode.classList.add("active");
	  currentSelection[modelKey] = true;
    }
  
  	return div;
}



        
/**
 * 
 * Añade parámetros a la URL
 * 
 * @param {string/array} parameterIndex Parámetro o array de parámetros a añadir
 * @param {string/array} parameterValue Valor o array de valores para el parámetro a añadir
 * @param {boolean} reload Si queremos recargar la página con los nuevos parámetros o no
 * 
 * @return {nothing/string} Devolverá la URL actualizada con los nuevos parámetros
 * 
 */
 function addParameterToUrl(parameterIndex, parameterValue, reload = true) {
  // Sacamos los parámetros de la URL actual
  let params = new URLSearchParams(location.search);

  // Si le hemos pasado un array iteraremos sobre él para añadir los valores
  if (Array.isArray(parameterIndex) && Array.isArray(parameterValue)) {
      parameterIndex.map((index, valueIndex) => {
          params.set(index, parameterValue[valueIndex]);
      });
  } else if (Array.isArray(parameterIndex) || Array.isArray(parameterValue)) {
      return console.error("Both parameters MUST be Arrays or Strings to add them to the URL");
  } else { // De lo contrario solo hay un parámetro a añadir
      params.set(parameterIndex, parameterValue);
  }

  // Si queremos recargar la página podemnos metérselo directamente al search parameter así
  if (reload) {
      window.location.search = params.toString(); 
      return;
  }
  
  // De lo contrario necesitamos "reconstruir" la URL con los nuevos parámetros
  let newUrl = window.location.href + "?"+params.toString();
  if (window.location.search) { // Si ya había parámetros los respetamos
      newUrl = window.location.href.replace(window.location.search, params.toString() ? "?"+params.toString() : "");
  }
  // Lo añadimos al historial de navegación y devolvemos la URL
  window.history.pushState('', document.title, newUrl);
  return newUrl;
}
        


function insoleChange(selectedSize, alternative_ids = null) {
  selectedSize = parseInt(selectedSize);
  // Safe checks!
  if (!selectedSize || selectedSize < 0 || selectedSize > 60) return;

  let ids = [
    "select-two-2",
    "select-two",
  ];

  if (alternative_ids !== null) {
    // Convert it to an array in case it's not
    ids = Array.isArray(alternative_ids) ? alternative_ids : [alternative_ids];
  }

  ids.forEach(id => {
      let selector = document.getElementById(id);
      if (!selector) return;
      selector.value = selectedSize;
      selector.onchange();
  });
}


let linkQuickProductListeners = (timeout = 100) => {
  let quickProductSliders = document.querySelectorAll(".quick-product-slider-container-slider");
  if (quickProductSliders.length <= 0) {
    let newTimeout = timeout * 1.5;
    return setTimeout(() => {
      console.log("Check later", newTimeout, quickProductSliders)
      linkQuickProductListeners(newTimeout);
    }, newTimeout);
  }

  quickProductSliders.forEach((quickProductSlider) => {
    linkQuickSliderEvent(quickProductSlider);
  });
}
linkQuickProductListeners();


function linkQuickSliderEvent(sliderContainer) {
  console.log("Hello", sliderContainer);
  if (sliderContainer.dataset.isProcessed) {
    return;
  }
  sliderContainer.dataset.isProcessed = true;

  
  let arrowLeft = document.createElement("div");
    arrowLeft.classList.add("quick-arrow", "quick-arrow-left")
    arrowLeft.innerHTML = `<svg viewBox="0 0 512 512"><g><path d="M367.954,213.588L160.67,5.872c-7.804-7.819-20.467-7.831-28.284-0.029c-7.819,7.802-7.832,20.465-0.03,28.284 l207.299,207.731c7.798,7.798,7.798,20.486-0.015,28.299L132.356,477.873c-7.802,7.819-7.789,20.482,0.03,28.284 c3.903,3.896,9.016,5.843,14.127,5.843c5.125,0,10.25-1.958,14.157-5.873l207.269-207.701 C391.333,275.032,391.333,236.967,367.954,213.588z"></path></g></svg>`;
  let arrowRight = document.createElement("div");
    arrowRight.classList.add("quick-arrow", "quick-arrow-right")
    arrowRight.innerHTML = `<svg viewBox="0 0 512 512"><g><path d="M367.954,213.588L160.67,5.872c-7.804-7.819-20.467-7.831-28.284-0.029c-7.819,7.802-7.832,20.465-0.03,28.284 l207.299,207.731c7.798,7.798,7.798,20.486-0.015,28.299L132.356,477.873c-7.802,7.819-7.789,20.482,0.03,28.284 c3.903,3.896,9.016,5.843,14.127,5.843c5.125,0,10.25-1.958,14.157-5.873l207.269-207.701 C391.333,275.032,391.333,236.967,367.954,213.588z"></path></g></svg>`;
  sliderContainer.parentElement.appendChild(arrowLeft);
  sliderContainer.parentElement.appendChild(arrowRight);

  var sliderDivs = sliderContainer.querySelectorAll('.quick-product');

  arrowLeft.addEventListener("click", () => {
    scrollToThe("left")
  });
  arrowRight.addEventListener("click", () => {
    scrollToThe("right")
  });

  let scrollToThe = (direction) => {
    let currentScrollLeft = sliderContainer.scrollLeft;
    currentScrollLeft = Math.max(currentScrollLeft, sliderDivs[0].offsetLeft);

    const marginWidthScreen = 0;
    let slideTo;
    if ( direction == 'left' ) {
        slideTo = Array.from(sliderDivs).reverse().find(slide => slide.offsetLeft - marginWidthScreen < currentScrollLeft).offsetLeft;
    } else if ( direction == 'right' ) {
        slideTo = Array.from(sliderDivs).find(slide => slide.offsetLeft - marginWidthScreen > currentScrollLeft).offsetLeft;
    }

    console.log("SlideTo: ", slideTo, "currentScrollLeft", currentScrollLeft);
    if (slideTo === undefined ) return;

    slideTo -= marginWidthScreen;
    moveSliderToOffSet(slideTo, direction);
  
  }
  
  let moveSliderToOffSet = (slideTo, direction) => {
    slideToTarget   = slideTo;
    directionTarget = direction;
    keepOnGoing     = true;
    startAnimating(60);
  }
      
  var slideToTarget;
  var directionTarget;
  var keepOnGoing = true;
  // This variables will keep trake of our game cycles. The last execution, the executions per seconds, etc.
  var fps, fpsInterval, startTime, now, then, elapsed;
  // Initialize the timming variables and start the animation loop
  let startAnimating = (fps) => {
    fpsInterval = 1000 / fps;
    then = Date.now();
    startTime = then;
    animateGame(); // Call the "recursive" function
  }
  
  // This is the function that renders all the login. It iterates itself using "requestAnimationFrame" (which is good for performance)
  let animateGame = () => {
  
    // Altough it may seem counter intuitive, we call it right at the start
    if (keepOnGoing)
      requestAnimationFrame(animateGame);

    // Keep track of the current timeframe
    now     = Date.now();
    elapsed = now - then; // Keep track of the time in between

    // If the time in between is greater that the executions per seconds time we execute the game logic
    if (elapsed > fpsInterval) { 
      // We keep track of the las time the function was executed
      then = now - (elapsed % fpsInterval);

      // Game logic goes here:
      if(directionTarget == "right") {
        sliderContainer.scrollLeft += 50;
        sliderContainer.scrollLeft = Math.min(sliderContainer.scrollLeft, slideToTarget);
        if(sliderContainer.scrollLeft >= slideToTarget || sliderContainer.scrollLeft == (sliderContainer.scrollWidth - sliderContainer.clientWidth ))
          keepOnGoing = false;

      } else {
        sliderContainer.scrollLeft -= 50;
        sliderContainer.scrollLeft = Math.max(sliderContainer.scrollLeft, slideToTarget);
        if(sliderContainer.scrollLeft <= slideToTarget || sliderContainer.scrollLeft == 0)
          keepOnGoing = false;
      }

    }
  }
  
  var screenWidth;
  let checkSliderSize = () => {
    screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    
    let control_left = arrowLeft;
    let control_right = arrowRight;

    if (sliderContainer.clientWidth != sliderContainer.scrollWidth) {
      if (sliderContainer.scrollLeft != 0) {
        control_left.style.display = "flex";
      } else {
        control_left.style.display = "none";
      }
      
      if (sliderContainer.scrollLeft != (sliderContainer.scrollWidth - sliderContainer.clientWidth )) {
        control_right.style.display = "flex";
      } else {
        control_right.style.display = "none";
      }
    } else {
      control_left.style.display = "none";
      control_right.style.display = "none";
    }


    for (let i = 0; i < sliderDivs.length; i++) {
      if (screenWidth > 600) {
        let newWidth = sliderContainer.clientWidth;
        sliderDivs[i].style.width    = newWidth+"px"; 
        sliderDivs[i].style.minWidth = newWidth+"px"; 
      } else {
        sliderDivs[i].style.width    = "100%"; 
        sliderDivs[i].style.minWidth = "100%"; 
      }
    }
  }

  window.addEventListener("resize", checkSliderSize);
  sliderContainer.addEventListener("scroll", checkSliderSize);
  window.addEventListener("orientationchange", checkSliderSize);
  let initSlider = () => {
    checkSliderSize();
    sliderDivs.forEach(sliderDiv => {
      if (!sliderDiv.classList.contains("default-slide")) {
        return;
      }
      moveSliderToOffSet(sliderDiv.offsetLeft, "right");
    });
  };
  document.addEventListener('DOMContentLoaded', initSlider);
  initSlider();

};


function quickAddToCart(element) {
  let variantId          = element.dataset.variantId;
  let hiddenFormSelector = document.getElementById(element.dataset.hiddenFormSelector);
  // let infoInput          = hiddenFormSelector?.parentElement.querySelector(`#quick-reserv-info-input`);
  // let textInput          = hiddenFormSelector?.parentElement.querySelector(`#quick-reserv-text-input`);
  if (!variantId || !hiddenFormSelector) {
    return;
  }

  let buttonSelector = document.getElementById(element.dataset.buttonSelector);
  
  let addToCart = () => {
    // Don't know why they removed this??
    // console.log(infoInput, textInput);
    // if (infoInput && textInput) {
    //   let reservText = element.dataset.productReservText;
    //   if (element.dataset.inventoryQuantity <= 0 && reservText && reservText !== "") {
    //     infoInput.name  = `properties[Info]`;
    //     infoInput.value = `Artículo en reserva`;
    //     textInput.name  = `properties[Entrega]`;
    //     textInput.value = reservText;
    //   } else {
    //     infoInput.name  = ``;
    //     infoInput.value = ``;
    //     textInput.name  = ``;
    //     textInput.value = ``;
    //   }
    // }
    // console.log(hiddenFormSelector.parentElement.querySelector(".submit-hidden-form"));
    hiddenFormSelector.value = variantId;
    hiddenFormSelector.parentElement.querySelector(".submit-hidden-form").click();
  };

  if (!buttonSelector || buttonSelector.style.display == "none") {
    return addToCart();
  }

  element.parentElement.querySelectorAll(".variant-size-selector").forEach(selector => {
    selector.classList.remove("selected");
  });
  element.classList.add("selected");
  buttonSelector.onclick = () => {
    element.classList.remove("selected");
    addToCart();
  };

}

function renderDesktopVersion(quickAddTrigger, parsedData, currentOption1, selector) {

  quickAddTrigger.classList.remove("quick-add-tooltip");
  quickAddTrigger.classList.add("quick-add-triggered");
  quickAddTrigger.innerHTML = ``;
  parsedData.variants.forEach(variant => {
      if (variant.option1 != currentOption1) return;

      let option2Selector = document.createElement("div");
          if (variant.available) {
              option2Selector.onclick = () => {
                  checkVariantAvailability(parsedData, variant.id);
                  selector.value = variant.id;
                  selector.parentElement.querySelector(".submit-hidden-form").click();
              };
          } else {
              option2Selector.classList.add("unavailable");
          }
          option2Selector.classList.add("option-2-selector");
          option2Selector.innerHTML = variant.option2;
      quickAddTrigger.appendChild(option2Selector);
  });
}
     
function checkVariantAvailability(productData, variantId) {
  let variantData = [];
  try {
      variantData = JSON.parse(document.getElementById(`variant_id_${variantId}`)?.innerHTML);
  } catch(e) {
      console.log("Malformed JSON on reserv texts", e);
  }
  let infoInput   = document.getElementById(`reserv-info-input-${productData.id}`);
  let textInput   = document.getElementById(`reserv-text-input-${productData.id}`);
  if (variantData.inventory_quantity <= 0 && variantData.reserve_text_clasicos.trim() && variantData.reserve_text_clasicos.trim() !== "") {
      infoInput.name  = `properties[Info]`;
      infoInput.value = `Artículo en reserva`;
      textInput.name  = `properties[Entrega]`;
      textInput.value = variantData.reserve_text_clasicos.trim();
  } else {
      infoInput.name  = ``;
      infoInput.value = ``;
      textInput.name  = ``;
      textInput.value = ``;
  }
  return true;
}
     
function renderMobileVersion(quickAddTrigger, parsedData, currentOption1, selector) {
  let content = document.createElement("div");
      content.classList.add("popup-container-content");
  let popup   = renderGenericPopup(content);
  
  // Sacamos las imágenes para el option actual
  let images = getImagesForOption1(parsedData, currentOption1);
  let imagesContainer = document.createElement("div");
      imagesContainer.classList.add("images-container");

      // Por defecto la primera estará seleccionad
      let currentImage = document.createElement("div");
          currentImage.classList.add("current-image");
          currentImage.style.backgroundImage = "url(" + images[0] + ")";
      imagesContainer.appendChild(currentImage);

      // El selector de imágenes contendrá el resto de imágenes (la principal también)
      let imageSelection = document.createElement("div");
          imageSelection.classList.add("image-selection");
          images.forEach(image => {
              let imgNode = document.createElement("div");
                  imgNode.classList.add("img-preview");
                  // Al cambiar de imagen tan solo cambia la seleccionada
                  imgNode.onclick = () => {
                      currentImage.style.backgroundImage = "url(" + image + ")";
                  };
                  imgNode.style.backgroundImage = "url(" + image + ")";
              imageSelection.appendChild(imgNode);
          });
      imagesContainer.appendChild(imageSelection)
  content.appendChild(imagesContainer);
      
  // Declaramos muy arriba el botón para poder cambiarlo cuando cambiemos de variantes
  let viewMoreButton = document.createElement("div");
  // Esta será la función base para ir al producto (tendrá que cambiar con la variante seleccionada)
  let gotToProductPage = (variantId) => {
      window.location = "/products/" + parsedData.handle + "/?variant=" + variantId;
  }

  // Usaremos esta variante para los valores por defecto de las cosas (precios, etc) 
  // La declaramos a la primera pero la cambiaremos a la primera de nuestra option1 que encontremos
  var sampleVariant = parsedData.variants[0]; 
  let optionsContainer = document.createElement("div");
      optionsContainer.classList.add("option-2-popup-container")

      // Recorremos todas nuestras opciones para hacer nuestros selectores de talla
      parsedData.variants.forEach(variant => {
          if (variant.option1 != currentOption1) return; // Saltamos todas las option1 que no sean la nuestra (colores)
          // actualizamos la variante por defecto a la nuestra
          sampleVariant = variant;

          // Creamos el selector
          let option2Selector = document.createElement("div");
              if (variant.available) {
                  option2Selector.onclick = () => {
                      content.querySelectorAll(".option-2-selector-mobile-popup").forEach(selector => selector.classList.remove("active"));
                      option2Selector.classList.add("active");
                      selector.value = variant.id;
                      viewMoreButton.onclick = () => {
                          gotToProductPage(variant.id);
                      }
                  };
              } else {
                  option2Selector.classList.add("unavailable");
              }
              option2Selector.classList.add("option-2-selector-mobile-popup");
              option2Selector.innerHTML = variant.option2;
          optionsContainer.appendChild(option2Selector);
      });
  content.appendChild(optionsContainer);

  let titlePriceContainer = document.createElement("div");
      titlePriceContainer.classList.add("title-price-container");
      
      let title = document.createElement("div");
          title.classList.add("quick-add-popup-title");
          title.innerHTML = parsedData.title.replaceAll("Hombre", "").replaceAll("Mujer", "").trim();
      titlePriceContainer.appendChild(title);

      let price = document.createElement("div");
          if (sampleVariant.compare_at_price && sampleVariant.compare_at_price > sampleVariant.price) {
            price.innerHTML = `
                ${(sampleVariant.price / 100).toString().replace(".",",") + "€"}
              <strike style="color: #c00;">${(sampleVariant.compare_at_price / 100).toString().replace(".",",") + "€"}</strike>
              `;
          } else {
            price.innerHTML = (sampleVariant.price / 100).toString().replace(".",",") + "€"
          }
      titlePriceContainer.appendChild(price);
  content.appendChild(titlePriceContainer);
  
  let currentColor = document.createElement("div");
      currentColor.classList.add("current-color");
      currentColor.innerHTML = sampleVariant.option1;
  content.appendChild(currentColor);
  
  let buttonsContainer = document.createElement("div");
      buttonsContainer.classList.add("buttons-container-popup");
      let addToCartButton = document.createElement("div");
          addToCartButton.classList.add("yuccs-button-primary", "yuccs-button-small");
          addToCartButton.innerHTML = `Añadir al carrito`;
          addToCartButton.style.width = "150px";
          addToCartButton.style.maxWidth = "100%";
          addToCartButton.style.textAlign = "center";
          addToCartButton.onclick = () => {
              checkVariantAvailability(parsedData, selector.value);
              selector.parentElement.querySelector(".submit-hidden-form").click();
              popup.remove();
          };
      buttonsContainer.appendChild(addToCartButton);
      // Created way up there let viewMoreButton = document.createElement("div");
      viewMoreButton.classList.add("yuccs-button-secondary", "yuccs-button-small");
      viewMoreButton.innerHTML = `Saber más`;
      viewMoreButton.style.width = "150px";
      viewMoreButton.style.maxWidth = "100%";
      viewMoreButton.style.textAlign = "center";
      viewMoreButton.onclick = () => {
          gotToProductPage(sampleVariant.id);
      };
      buttonsContainer.appendChild(viewMoreButton);
  content.appendChild(buttonsContainer);

}

function getImagesForOption1(productData, option1) {
  var optionKey   = 0;
  var optionCount = 0;
  var lastOption  = "";
  productData.variants.forEach((variant, key) => {
      
      if (lastOption != variant.option1) {
          optionCount++;
          lastOption = variant.option1;
          if (lastOption == option1) {
              optionKey = optionCount - 1;
          }
      }
  });
  let photosPerOption = productData.images.length / optionCount;
  optionKey *= photosPerOption;
  let productImages = [];
  for (let index = optionKey; index < optionKey + photosPerOption; index++) {
      productImages.push(productData.images[index]);
  }
  return productImages;
}

/**
 * 
 * @param content TypeNode
 */
function renderGenericPopup(content) {
  let container = document.createElement("div");
    container.classList.add("model-selector-bg-container");
   
      let closeGenericPopup = () => {
        container.remove();
      };

      container.onclick = (event) => {
        if (event.target !== container) return;
        closeGenericPopup();
      };

    let selector = document.createElement("div");
      selector.classList.add("model-selector-container");

      let selectorHead = document.createElement("div");
        selectorHead.classList.add("model-selector-head");
              selectorHead.style.border = "none";
        
        let selectorTitle = document.createElement("div");
          selectorTitle.classList.add("model-selector-title");
          selectorTitle.innerHTML = ``;
        selectorHead.appendChild(selectorTitle);
        

        let selectorClose = document.createElement("div");
          selectorClose.classList.add("model-selector-close");
          selectorClose.innerHTML = `<svg fill="currentColor" viewBox="0 0 24 24" width="24px" height="24px"><path d="M 4.7070312 3.2929688 L 3.2929688 4.7070312 L 10.585938 12 L 3.2929688 19.292969 L 4.7070312 20.707031 L 12 13.414062 L 19.292969 20.707031 L 20.707031 19.292969 L 13.414062 12 L 20.707031 4.7070312 L 19.292969 3.2929688 L 12 10.585938 L 4.7070312 3.2929688 z"/></svg>`;
          selectorClose.onclick = closeGenericPopup;
        selectorHead.appendChild(selectorClose);


      selector.appendChild(selectorHead);
      
          
          let selectorBody = document.createElement("div");
              selectorBody.appendChild(content)
          selector.appendChild(selectorBody);



    container.appendChild(selector);


  document.body.appendChild(container);

  return container;
}